import { Box, SelectChangeEvent } from "@mui/material";
import BreadCrumb from "../DashboardBreadCrumb/DashboardBreadCrumb";
import CustomerDetailsCard from "../CustomerDetailsCard/CustomerDetailsCard";
import { CustomerDetailsListStyles } from "./CustomerDetailsListStyles";
import Button from "../../common/CustomButton/CustomButton";
import { CustomerDetailsButton } from "../../constants/CustomerDetailsButtons";
import Drawers from "../Drawers/Drawers";
import NewTask from "../NewTask/NewTask";
import {
  CRISTOFER,
  CRISTOFER_ID,
  MENU_ICON,
  NEW_TASK,
  NOTES,
} from "../../constants";
import { Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import BasicTabs from "../../common/BasicTabs/BasicTabs";
import Tables from "../Tables/Tables";
import InteractionHistory from "../InteractionHistory/InteractionHistory";
import CustomerDetailsNotes from "../CustomerDetailsNotes/CustomerDetailsNotes";
import CustomerDetailsOverView from "../CustomerDetailsOverView/CustomerDetailsOverView";
import menuIcon from "../../assets/svgs/menu-icon.svg";
import { useNavigate, useParams } from "react-router-dom";
import SendRemainder from "../SendRemainder/SendRemainder";
import ClaimHistory from "../ClaimHistory/ClaimHistory";
import PaymentMethod, {
  PaymentMethodCardDataProps,
} from "../PaymentMethod/PaymentMethod";
import { PersonChatProps } from "../CustomerDetailsNotes/CustomerDetailsNotes";
import { sendRemaindersAndShareMarketData } from "../../constants/SendRemaindersAndShareMarketData";
import Notes from "../Notes/Notes";
import { personData } from "../../constants/myTasksPersonData";
import { personChat } from "../../constants/myTasksPersonChatData";
import {
  PostCustomerDetails,
  PostCustomerPolicies,
} from "./CustomerDetailsListActions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getCookie, isFeatureAvailable } from "../../utils/Utility";
import { RootState } from "../../store/store";
import { GetPoliciesData } from "../../customers/Dashboard/DashboardAction";
import BillingTabComponent from "../../customers/PolicyDetails/policyTabComponents/Billing/Billing";
import ModalComponent from "../../common/ModalComponent/ModalComponent";
import DropDown from "../../common/DropDown/DropDown";
import ClaimFlow from "../ClaimFlow/ClaimFlow";
import {
  IPolicyDetailsHeader,
  IProducerDetails,
  IProducerDetailsAddress,
} from "../../models/user/policyDetails/PolicyDetails";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import CustomSelect from "../../components/common/Select";

export interface OverviewTableDataProps {
  policyType: string;
  policyDetails: {
    policyNumber: string;
    policyTypeNumber: string;
  };
  policyStatus: string;
  policyPremium: string;
  policyTerm: string;
  expiryDate: string;
  policyLastPayment: string;
}
export interface InvoicesTableDataProps {
  invoice: string;
  policyDetails: {
    policyNumber: string;
    policyTypeNumber: string;
  };
  billingDate: string;
  amount: string;
  paymentMethod: string;
  paidOn: string;
}
interface MyTasksClientDetailsProps {
  clientName: string;
  clientEmail: string;
  clientPhone: string;
}
export interface MytasksDataProps {
  timeStamp: {
    date: string;
    time: string;
  };
  task: string;
  clientDetails: MyTasksClientDetailsProps;
  policy: string;
  priority: string;
  status: string;
}
export interface CustomerDetailsOverviewProps {
  overviewPolicyData: OverviewTableDataProps[];

  overviewTableHeaders: string[];
}
export interface CustomerDetailsInvoicesProps {
  invoicesTableHeaders: string[];
  invoicesData: InvoicesTableDataProps[];
}
interface HeadingSubheadingProps {
  heading: string;
  subheading: string;
}

export interface ClaimHistoryProps {
  claimId: string;
  active: boolean;
  claimsData: HeadingSubheadingProps[];
}
export interface InteractionHistoryDataProps {
  left: string;
  cardIcon: string;
  idNumber: string;
  interaction: string;
  text: string;
  profileIcon: string;
  agentName: string;
}
export interface CustomerDetailsHeaderCardDataProps {
  policyDetails: Array<{
    heading: string;
    subheading: string;
  }>;
  claimDetails: Array<{
    heading: string;
    subheading: string;
  }>;
  contactDetails: Array<{
    image: string;
    text: string;
  }>;
  interactionDetail: {
    text: string;
  };
}

interface PolicyDetails {
  carrier: string;
  count: number;
  statusCd: string;
  system: string;
}

export interface Policies {
  totalPolicies: PolicyDetails;
  activePolicies: PolicyDetails;
  cancelNoticePolicies: PolicyDetails;
  cancelledPolicies: PolicyDetails;
  renewalInprogressPolicies: PolicyDetails;
  nonRenewRequestedPolicies: PolicyDetails;
  nonPayCancelledPolicies: PolicyDetails;
  futureExpiredPolicies: PolicyDetails;
}

interface CustomerDetailsListProps {
  customerOverViewData: CustomerDetailsOverviewProps;
  customerTasksData: any[];
  customerInvoicesData: CustomerDetailsInvoicesProps;
  claimHistoryData: {
    activeClaimsData: ClaimHistoryProps[];
    pastClaimsData: ClaimHistoryProps[];
  };
  interactionHistoryData: InteractionHistoryDataProps[];
  paymentMethodCardData: PaymentMethodCardDataProps[];
  customerHeaderCardData: Policies;
  notesChatData: PersonChatProps[];
}
const CustomerDetailsList: React.FC<CustomerDetailsListProps> = ({
  customerOverViewData,
  customerTasksData,
  customerInvoicesData,
  claimHistoryData,
  interactionHistoryData,
  paymentMethodCardData,
  customerHeaderCardData,
  notesChatData,
}) => {
  const dispatch = useAppDispatch();
  const { customerId } = useParams();
  const carrier = getCookie("carrier");
  const system = getCookie("system");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState("");
  const [open, setOpen] = React.useState(false);
  const [heading, setHeading] = React.useState("");
  const [primary, setPrimary] = React.useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const { policyList, customerDetails } = useAppSelector(
    (state: RootState) => state.customerPolicies
  );
  const { features } = useAppSelector((state: RootState) => state.features);

  const overviewPolicyData = policyList.map(
    ({
      policyType,
      carrierPolicyNo,
      carrierPolicyStatus,
      totalPremium,
      tenure,
      expiryDate,
      dueDate,
      dueAmount,
      policyId,
      carrier,
      customerId,
      system,
      lobCode,
      finalPremiumAmount,
    }) => ({
      policyType,
      policyDetails: {
        policyNumber: carrierPolicyNo,
        policyTypeNumber: policyType,
      },
      policyStatus: carrierPolicyStatus,
      policyPremium: `$${finalPremiumAmount}`,
      policyTerm: tenure,
      expiryDate: expiryDate,
      policyLastPayment: dueAmount
        ? `${dueDate} | $${dueAmount}`
        : "No Pending Dues",
      policyId,
      carrier,
      customerId,
      system,
      lobCode,
    })
  );

  useEffect(() => {
    if (customerId && carrier && system) {
      
      dispatch(PostCustomerDetails({
        customerId: customerId,
        carrier: carrier,
        system: system
      }))
    }
  }, [customerId, carrier, system, dispatch]);

  useEffect(() => {
    if (customerId && carrier && system) {
      dispatch(PostCustomerPolicies({
        customerId: customerId,
        carrier: carrier,
        system: system
      }));
    }
  }, [customerId, carrier, system, dispatch]);

  useEffect(() => {
    if (customerId && carrier && system) {
       
      dispatch(GetPoliciesData({
        customerId: customerId,
        carrier: carrier,
        system: system
      }))
    }
  }, [customerId, carrier, system, dispatch]);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const { policiesData } = useAppSelector(
    (state: RootState) => state.dashboard
  );

  const firstInsuredName = policiesData?.policyList?.[0]?.insuredName;

  const handleButtonAction = (key: string) => {
    if (key === "Edit") {
      console.log("edit");
    } else if (key === "CALL") {
      console.log("call");
    } else if (key === "MARKETING") {
      toggleDrawer();
      setHeading("Share Marketing Collateral");
      setPrimary(true);
    } else if (key === "ADD NOTES") {
      setNotesOpen(true);
    }
  };
  const handleNotesClick = () => {
    setNotesOpen(!notesOpen);
  };
  const customerDetailsTabData = [
    {
      label: "Overview",
      content: (
        <CustomerDetailsOverView
          overviewPolicyData={
            isFeatureAvailable({
              featureCodes: ["customer_details_mock_data"],
              features,
            })
              ? customerOverViewData.overviewPolicyData
              : overviewPolicyData
          }
          tasksData={customerTasksData}
          overviewTableHeaders={customerOverViewData.overviewTableHeaders}
        />
      ),
    },
    {
      label: "Billing",
      content: <BillingTabComponent agentBilling="Billing" />,
      // <BillingTabComponent />,
    },
    // {
    //   label: "Payment Methods",
    //   content: <PaymentMethod paymentMethodCardData={paymentMethodCardData} />,
    // },
    {
      label: "Claim History",
      content: <ClaimHistory />,
    },
    /*
    {
      label: "Interaction History",
      content: (
        <InteractionHistory interactionHistoryData={interactionHistoryData} />
      ),
    },
    */
    {
      label: "Notes",
      content: <CustomerDetailsNotes personChatArray={notesChatData} />,
    },
  ];
  const navigate = useNavigate();

  const handleRemainderChange = (event: SelectChangeEvent) => {
    setSelectedDropdownValue(event.target.value as string);
  };

  const [fnolModalOpen, setFnolModalOpen] = useState(false);
  const [selectedPolicyId, setSelectedPolicyId] = useState("");
  const [showClaimFlow, setShowClaimFlow] = useState(false);
  const [selectedPolicy, setSelectedPolicy] =
    useState<IPolicyDetailsHeader | null>(null);
  const [selectedPolicyForClaim, setSelectedPolicyForClaim] = useState<{
    policyId: string;
    lobCode: string;
  } | null>(null);

  const handleOpenFnolModal = () => {
    if (policyList.length > 0) setFnolModalOpen(true);
  };
  const handleCloseFnolModal = () => {
    setFnolModalOpen(false);
    setSelectedPolicyId("");
    setSelectedPolicy(null);
    setSelectedPolicyForClaim(null);
  };
  const handlePolicySelect = (value: string) => {
    const selected = policyList.find((p) => p.policyId === value);

    if (selected?.lobCode === "PA") {
      setSelectedPolicyId(value); // set only if PA
    }
  };
  function mapPolicyToPolicyDetailsHeader(policy: any): IPolicyDetailsHeader {
    return {
      carrierPolicyNumber: policy.carrierPolicyNo,
      tenure: policy.tenure,
      carrierPolicyStatus: policy.carrierPolicyStatus,
      productName: "", // Not available in Policy
      riskCount: policy.riskCount,
      lobCode: policy.lobCode,
      effectiveDate: policy.effectiveDate,
      expiryDate: policy.expiryDate,
      inforcePremium: policy.inforcePremium,
      totalFeeAmount: policy.totalFeeAmount,
      totalPremium: policy.totalPremium,
      insuredName: policy.insuredName,
      insuredNameJoint: policy.insuredNameJoint,
      policyType: policy.policyType,
      paymentPlan: "",
      accountType: policy.accountType || "",
      accountId: policy.accountId,
      payPlanType: policy.payPlanType || null,
      dueDate: policy.dueDate,
      dueAmount: policy.dueAmount,
      carrier: policy.carrier,
      system: policy.system,
      producerId: policy.producerId || "",
      riskList: [],
      policyHeaderBillingDetails: [],
      producerDetails: {
        address: {
          addr1: "",
          addrTypeCd: "",
          city: "",
          county: "",
          countyCode: "",
          postalCode: "",
          regionCd: "",
          regionISOCd: "",
          stateProvCd: "",
        },
        agencyName: "",
        emailInfo: "",
        nameInfo: "",
        phoneInfo: "",
        producerId: policy.producerId || "",
      },
      isLegalNotice: policy.isLegalNotice,
      personalUmbrellaLiabilityLimit:
        policy.personalUmbrellaLiabilityLimit || 0,
      insuredList: policy.insuredList || null,
      finalPremiumAmount: policy.finalPremiumAmount,
    };
  }

  const handleFnolProceed = () => {
    const policy =
      policyList.find((p) => p.policyId === selectedPolicyId) || null;
    setSelectedPolicy(policy ? mapPolicyToPolicyDetailsHeader(policy) : null);
    setSelectedPolicyForClaim(
      policy ? { policyId: policy.policyId, lobCode: policy.lobCode } : null
    );
    setShowClaimFlow(!!policy);
    setFnolModalOpen(false);
    setSelectedPolicyId("");
  };

  return (
    <>
      {showClaimFlow && selectedPolicy ? (
        <ClaimFlow
          onBack={() => setShowClaimFlow(false)}
          onSubmit={() => setShowClaimFlow(false)}
          customerDetails={customerDetails}
          policyDetailsHeader={selectedPolicy}
          policyid={selectedPolicyForClaim?.policyId}
          lobCode={selectedPolicyForClaim?.lobCode}
        />
      ) : (
        <Box sx={CustomerDetailsListStyles.container}>
          <Box sx={CustomerDetailsListStyles.headerContainer}>
            <BreadCrumb
              variant={"primary"}
              text={firstInsuredName || ""}
              handleClick={() => navigate("/agent/customerListing")}
            />

            <Box sx={CustomerDetailsListStyles.buttonsContainer}>
              {CustomerDetailsButton.map((button, index) => (
                <Button
                  key={index}
                  type="outlined"
                  text={button.text}
                  onClick={() => handleButtonAction(button.key)}
                  additionalClassName={CustomerDetailsListStyles.button}
                />
              ))}
              <Button
                type="outlined"
                text="Add FNOL"
                onClick={handleOpenFnolModal}
                additionalClassName={CustomerDetailsListStyles.button}
                disabled={policyList.length === 0}
              />
              {/* <Box sx={CustomerDetailsListStyles.menuIcon}>
                <img src={menuIcon} alt={MENU_ICON} />
              </Box> */}
            </Box>
          </Box>
          <Box>
            <CustomerDetailsCard data={customerHeaderCardData} />
          </Box>
          <Drawers
            open={open}
            toggleDrawer={handleClick}
            heading={NEW_TASK}
            additionalClass={CustomerDetailsListStyles.drawer}
          >
            <NewTask onCancelClick={handleClick} />
          </Drawers>
          <Box sx={CustomerDetailsListStyles.tabs}>
            <BasicTabs
              additionalLabelClass={CustomerDetailsListStyles.tabsText}
              tabs={customerDetailsTabData}
            />
          </Box>
        </Box>
      )}
      <Drawers open={drawerOpen} toggleDrawer={toggleDrawer} heading={heading}>
        <SendRemainder
          onCancelClick={toggleDrawer}
          recieverName={sendRemaindersAndShareMarketData.recieverName}
          dropDownData={sendRemaindersAndShareMarketData.dropdownData}
          primary={primary}
          fileUploadName={sendRemaindersAndShareMarketData.fileUploadName}
          fileUploadSize={sendRemaindersAndShareMarketData.fileUploadSize}
          handleRemainderChange={handleRemainderChange}
          selectedDropdownValue={selectedDropdownValue}
        />
      </Drawers>
      <Drawers open={notesOpen} toggleDrawer={handleNotesClick} heading={NOTES}>
        <Notes
          personDataArray={personData}
          personChatArray={personChat}
          handleNotesClick={handleNotesClick}
          setOpenSnackbar={setOpenSnackbar}
          customerDetails={customerDetails}
        />
      </Drawers>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
        >
          Note saved successfully!
        </Alert>
      </Snackbar>

      <ModalComponent
        heading="Select Policy for FNOL"
        open={fnolModalOpen}
        handleOpen={handleCloseFnolModal}
        additionalClassContainer={CustomerDetailsListStyles.modalContainer}
        headingAdditionalClass={CustomerDetailsListStyles.modalHeading}
        headingContainerAdditionalClass={
          CustomerDetailsListStyles.modalHeadingContainer
        }
        additionalModalClass={{ p: 0, width: "100%" }}
      >
        <Box sx={CustomerDetailsListStyles.modalContent}>
          <CustomSelect
            label="Select Policy"
            value={selectedPolicyId}
            onChange={handlePolicySelect}
            options={policyList.map((p) => ({
              value: p.policyId,
              label: `${p.carrierPolicyNo} | ${p.effectiveDate}-${p.expiryDate} | ${p.insuredList?.[0]?.businessName}`,
              disabled: p.lobCode !== "PA"
            }))}
            placeholder="Select a policy"
            id="policy-select"
            data-test-id="policy-select"
          />

          <Box sx={CustomerDetailsListStyles.modalButtonContainer}>
            <Button
              type="outlined"
              text="Cancel"
              onClick={handleCloseFnolModal}
              additionalClassName={CustomerDetailsListStyles.modalCancelButton}
              disabled={false}
            />
            <Button
              type="outlined"
              text="Proceed"
              onClick={handleFnolProceed}
              additionalClassName={CustomerDetailsListStyles.modalProceedButton}
              disabled={!selectedPolicyId}
            />
          </Box>
        </Box>
      </ModalComponent>
    </>
  );
};

export default CustomerDetailsList;
